import { render, staticRenderFns } from "./FormLearningOutcomes.vue?vue&type=template&id=5bb78c6f&"
import script from "./FormLearningOutcomes.vue?vue&type=script&lang=js&"
export * from "./FormLearningOutcomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports